<template>
  
  <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li
          class="tabLi"
          v-for="(data,$index) in langData"
          :key="$index"
          :class="{'active':$index==0}"
        >
          <div class="tabDiv" @click="changeTab($index)"></div>
          <a
            :class="true?'tab'+$index:''"
            data-toggle="tab"
            :href="true?'#tab-'+$index:''"
            aria-expanded="true"
            @click="showTab($event,$index)"
          >{{ $t("message." + data) }}</a>
        </li>
      </ul>
    </div>
    <el-form  :model="socialMediaDetail" ref="socialMediaDetail"  label-width="0px" class="demo-dynamic form-horizontal detailPage">
      <div class="tab-content">
        <div
          :id="'tab-'+index"
          v-for="(langItem, index) in socialMediaDetail.langMap"
          :key="index"
          class="tab-pane"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Venue Name
                </label>
                <div class="col-sm-10">
                  <el-form-item 
                      :prop="'langMap.' + index + '.venueName'"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'blur'
                      }"
                    >
                    <el-input v-model="langItem.venueName" show-word-limit :maxlength="200" ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Social Medias:
                </label>
              </div>
              <div class="form-group row">
                  <div class="col-sm-12">
                    <draggable 
                      class="sortable-list connectList0 agile-list"
                      style="margin-bottom: 15px;padding:0 15px;"
                      v-model="socialMediaDetail.socialMedias" 
                      group="people" 
                      @start="drag=true" 
                      @end="drag=false"
                      >
                       <div v-for="(task,i) in socialMediaDetail.socialMedias" class="dragObj form-group">

                          <div class="form-group">
                            <label class="col-sm-2 control-label">
                              Social Media Option
                            </label>
                            <div class="col-sm-10">
                              <el-form-item 
                                  :prop="'socialMedias.' + i + '.socialMediaOption'"
                                  :rules="{
                                    required: true, message: $t('message.required'), trigger: 'change'
                                  }"
                                >
                                <el-select v-model="task.socialMediaOption" clearable >
                                    <el-option 
                                    v-for="item in socialMediaOptionObj"
                                    :key="item.label"
                                    :label="item.label"
                                    :value="item.label">
                                    </el-option>
                                </el-select>
                              </el-form-item>
                            </div>
                          </div>
                          <div v-for="(lang,k) in task.langMap" v-if="lang.langCode == langItem.langCode">
                            <div class="form-group" v-if="task.socialMediaOption!='Wechat'" >
                              <label class="col-sm-2 control-label">
                                Description
                              </label>
                              <div class="col-sm-10">
                                <el-form-item 
                                    :prop="'socialMedias.'+ i +'.langMap.'+ k + '.description'"
                                    :rules="{
                                      required: true, message: $t('message.required'), trigger: 'blur'
                                    }"
                                  >
                                  <el-input   v-model="lang.description" show-word-limit :maxlength="1000" ></el-input>
                                </el-form-item>
                              </div>
                            </div>
                            <div class="form-group" v-if="task.socialMediaOption!='Wechat'" >
                              <label class="col-sm-2 control-label">
                                Url
                              </label>
                              <div class="col-sm-10">
                                <el-form-item 
                                    :prop="'socialMedias.'+ i +'.langMap.'+ k + '.url'"
                                    :rules="{
                                      required: true, message: $t('message.required'), trigger: 'blur'
                                    }"
                                  >
                                  <el-input v-model="lang.url" show-word-limit :maxlength="1000" ></el-input>
                                </el-form-item>
                              </div>
                            </div>
                          </div>
                          <a class="pull-right btn btn-xs btn-white" style="position: absolute;top: 10px;right: 10px;" @click="deleteSocialMedia(i)"><i class="fa fa-trash-o" ></i></a>
                       </div>
                    </draggable>
                  </div>
              </div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div class="btn btn-primary" @click="addSocialMedia()">Add Social Media</div>
                  </div>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div class="btn btn-primary" v-if="checkPermission('SOCIAL_MEDIA_LIST_NEW')||checkPermission('SOCIAL_MEDIA_LIST_UPDATE')"  @click="checkEvent()">{{$t("message.Save") }}</div>
                    <div class="btn btn-white" @click="showWarning()">{{$t("message.Cancel") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import fileupload from "../components/common/fileupload";
import eventBus from "../eventbus";
import config from "../config";
import draggable from 'vuedraggable'

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      socialMediaDetail:{
        socialMedias:[],
        langMap:[{
            langCode:'en_US',
            title:"",
            greeting:"",
            message:"",
        },{
            langCode:'zh_CN',
            title:"",
            greeting:"",
            message:"",
        },{
            langCode:'zh_HK',
            title:"",
            greeting:"",
            message:"",
        }],
      },
    };
  },
  computed:{
      _language(){
        return this.$store.state.userInfo.langCode
      }
  },
  watch: {
    _language:function(){
      this.setObj();
    },
    socialMediaDetail: {
        handler: function(val, oldval) {
          this.$store.state.edit = true;
        },
        deep: true
    }
  },
  components: {
    draggable,
    "file-upload": fileupload
  },
  created() {
    this.setObj();
    this.init();
  },
  mounted() {
    setTimeout(function(){
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    })
  },
  methods: {
    setObj:function(){
      this.socialMediaOptionObj=[{
        label: 'Facebook'
      }, {
        label: 'Twitter'
      }, {
        label: 'Weibo'
      }, {
        label: 'Youtube'
      }, {
        label: 'Wechat'
      }, {
        label: 'Instagram'
      }]
    },
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj();
        obj.socialMediaId = id;
        obj.apiUrl = '/getSocialMediaDetail'
        var data = await this.$store.dispatch("apiEvent", obj);
        if(!data) return;
        data.data.result.status+="";
        this.$set(this, "socialMediaDetail", data.data.result);
        var that = this;
        setTimeout(function(){
          that.$store.state.edit = false;
        })
      } else {
      }
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        this.goBack();
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [{
              name:this.$i18n.t("message.Confirm"),
              callBack:function(){
                that.callDelete();
              }
            }, {
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){}
            }]
        });
      }
    },
    goBack() {
      this.$router.push({
        path: "/main/socialMediaList",
        query: { ...this.$route.query }
      });
    },
    checkEvent:function(){

        this.$refs["socialMediaDetail"].validate((valid) => {
          if (valid) {
            this.submit();
          } else {
            this.$toastr.w(this.$i18n.t("message.fillRequired"));
            return false;
          }
        });
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        for(var key in this.socialMediaDetail){
          var detail = JSON.stringify(this.socialMediaDetail[key])
          obj[key] = JSON.parse(detail);
        }
        obj.langMap = JSON.stringify(obj.langMap);
        obj.socialMedias = JSON.stringify(obj.socialMedias);
        if(this.$route.query.id){
          obj.socialMediaId = this.$route.query.id;
          obj.apiUrl = '/updateSocialMedia'
          var data = await this.$store.dispatch("apiEvent", obj);
        }else{
          obj.apiUrl = '/createSocialMedia'
          var data = await this.$store.dispatch("apiEvent", obj);
        }
        if(!data) return;
        if (data.data.errorCode === 0) {
          this.$store.state.edit = false;
          this.goBack();
        }
      } catch (err) {
      }
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
      try {
        let obj = this.getAuthObj();
        obj.ids = this.$route.query.id;
          obj.apiUrl = '/deleteSocialMedia'
          var data = await this.$store.dispatch("apiEvent", obj);
        if(!data) return;
        if (data.data.errorCode === 0) {
          this.$store.state.edit = false;
          this.goBack();
        }
      } catch (err) {
      }
    },
    langLabel(lang) {
      if (lang === "en_US") {
        return "EN";
      } else if (lang === "zh_HK") {
        return "T. Chi.";
      } else if (lang === "zh_CN") {
        return "S. Chi.";
      }
    },
    changeTab: function(id) {
      $(".tab" + id)
        .parent()
        .find("a")
        .click();
    },
    showTab: function($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
    deleteSocialMedia:function(index){
      this.$delete(this.socialMediaDetail.socialMedias,index);
    },
    addSocialMedia:function(){
      this.socialMediaDetail.socialMedias.push({
        socialMediaOption:"",
        langMap:[{
            langCode:'en_US',
            description:"",
            url:"",
        },{
            langCode:'zh_CN',
            description:"",
            url:"",
        },{
            langCode:'zh_HK',
            description:"",
            url:"",
        }],
      })
    }
  }
};
</script>
